export const defaultCompanyUser = {
    id: "",
    profile: {
        id: "",
        tags: []
    },
    investment: {
        capitalShare: 0,
        amount: 0
    },
    role: "UNKNOWN",

    configuration: {
        outstanding: {
            client: false,
            selectionClient: false,
            supplier: false,
            expenseReport: false,
            salary: false
        },
        payments: {
            salary: false,
            expenseReport: false,
            supplier: false
        },
        validation: {
            supplier: false
        }
    },
    accessRights: [],
    clients: []
}
